import globalCommon from './common/global.common';
import globalConfig from './global.config';
import globalModels from './models/global.models';
import globalLocale from './global.locale';
import globalRouter from './global.router';
import globalTracking from './global.tracking';
import globalUi from './global.ui';
import globalGrowthBook from './global.growthbook';

// import globalDigestHud from './global.digest-hud';

import _ from 'lodash';
import { extensionIntegrEvents } from '../modules/extensions-framework/angular-integration/integration-types';
import { saveAfterLoginPath } from '../store/features/system';
import * as sso from '../modules/sso';
import { setPatientContextGetter } from '../vendor/api';

/** Patient-facing state names (must match global.config.js). Ensures fetch API sends X-Doxyme-User-Role when in patient context. */
const patientFacingStateNames = new Set(['home', 'wrongRoom', 'patient']);

export default angular
  .module('doxy.global', [
    globalCommon,
    globalConfig,
    globalModels,
    globalLocale,
    globalRouter,
    globalTracking,
    globalUi,
    globalGrowthBook,
  ])
  .run(function ($rootScope, globalUi) {
    $rootScope.$on('modal.show', function () {
      globalUi.ui.modalOpen = true;
      $rootScope.$applyAsync();
      $rootScope.$emit(extensionIntegrEvents.ANGULAR_MODAL_OPEN);
    });

    $rootScope.$on('modal.hide', function () {
      globalUi.ui.modalOpen = false;
      $rootScope.$emit(extensionIntegrEvents.ANGULAR_MODAL_CLOSE);
    });
  })
  .run(function ($state) {
    setPatientContextGetter(
      () =>
        $state.current?.name != null &&
        patientFacingStateNames.has($state.current.name)
    );
  })
  .controller(
    'GlobalController',
    function (
      $rootScope,
      $scope,
      $state,
      $timeout,
      $window,
      $modal,
      $stateParams,
      User,
      globalUi,
      $interval,
      Browser,
      LoopBackAuth,
      globalHelpers,
      $log,
      checkOnline,
      notificationFactory,
      routerHelperFactory,
      cannyFactory,
      trackingFactory,
      growthbookFactory,
      communicationControl,
      env,
      VideoProviderFactory,
      $ngRedux
    ) {
      VideoProviderFactory.decorateScope(this);

      this.isManifestEnabled = Browser.shouldEnableManifest();

      this.state = {};
      this.ui = globalUi.ui;
      $rootScope.$state = $state;
      $rootScope.globalState = {
        beta: {
          extensionStore: false,
        },
      };
      $rootScope.__ = globalHelpers;
      const subdomain = routerHelperFactory.getSubdomain();

      let errorRedirectCount = 0;

      $rootScope.$on(
        '$stateChangeSuccess',
        (e, next, fromState, fromParams) => {
          if (
            fromParams.name === 'account.dashboard' &&
            ($stateParams.afterSignup || $stateParams.afterLogin)
          ) {
            $stateParams.afterSignup = false;
            $stateParams.afterLogin = false;
          }
          const data = next.data || {};
          this.state.bodyClass = data.bodyClass;
          this.state.title = data.title || 'home.title.default';
          this.state.metaTags = data.metaTags || {};
          this.state.description = data.description || '';
          this.state.prerenderStatusCode = data.prerenderStatusCode || '';
          this.isPatient = $rootScope.currentState === 'patient';
          errorRedirectCount = 0;
        }
      );

      $rootScope.$on(
        '$stateChangeError',
        function (event, toState, toParams, fromState, fromParams, error) {
          $log.debug('$stateChangeError', {
            action: '$stateChangeError',
            error: error,
          });

          if (_.get(error, 'detail.code') === 'MODULE_NOT_FOUND') {
            error.notification = {
              level: 'error',
              message: 'module-not-found',
              id: 'module-not-found',
            };
          }

          const notification =
            error.notification || _.get(error, 'detail.notification');
          if (notification) {
            notificationFactory.showCommon(
              notification.level,
              notification.message,
              notification.id
            );
          }

          if (
            _.get(error, 'detail.xhrStatus') === 'error' &&
            _.get(error, 'detail.status') === -1
          )
            return;

          const start = env === 'development' ? 'signIn' : 'home';
          const target = _.get(error, 'detail.target') || error.target || start;
          const data = _.get(error, 'detail.data') || error.data || {};

          if (errorRedirectCount < 5) {
            errorRedirectCount++;
            $state.go(target, data);
          } else {
            errorRedirectCount = 0;
          }
        }
      );

      $rootScope.$on('updatePageMeta', (e, meta = {}) => {
        $timeout(() => {
          this.state = Object.assign(this.state, meta);
          window.prerenderReady = true;
        });
      });

      $rootScope.$on(
        '$stateChangeStart',
        function (e, toState, toParams, fromState) {
          var data = toState.data || {};
          var previousData = (fromState && fromState.data) || {};
          if (data.reload && toState.url !== previousData.url) {
            e.preventDefault();
            return $window.location.assign(toState.url);
          }
          /**
           * Previously, User.isAuthenticated() returned true if LoopBackAuth.currentUserId was set — which worked
           * because we always stored both currentUserId and accessTokenId together (OG).
           * With the Frontegg integration, we’ve stopped storing LoopBackAuth.accessTokenId,
           * but currentUserId still persists.
           * This can cause User.isAuthenticated() to incorrectly return true for unauthenticated users.
           * To fix this, we now explicitly check that both currentUserId and accessTokenId are present.
           */
          const loggedIn =
            User.isAuthenticated() && Boolean(LoopBackAuth.accessTokenId);
          $ngRedux.dispatch(sso.actions.checkForSsoRequest());
          const ssoRequest = sso.selectors.selectSsoRequest(
            $ngRedux.getState()
          );
          const ssoAutoLoginStateName = 'ssoAutoLogin';
          if (
            Boolean(loggedIn) &&
            ssoRequest &&
            toState.name !== ssoAutoLoginStateName
          ) {
            e.preventDefault();
            $state.go(ssoAutoLoginStateName);
            return null;
          }

          var newTarget;
          var accessObj = (toState.data && toState.data.access) || {};
          var access = {
            level: accessObj.level || 'authenticated',
            institution: angular.isUndefined(accessObj.institution)
              ? true
              : accessObj.institution,
          };
          var defaultRoute = subdomain ? 'home' : 'signIn';
          if (access.level === 'authenticated' && !loggedIn) {
            newTarget = defaultRoute;
          } else if (access.level === 'unauthenticated' && loggedIn) {
            newTarget = 'account.dashboard';
          } else if (!access.institution && subdomain) {
            newTarget = defaultRoute;
          }

          if (newTarget) {
            e.preventDefault();
            const cannyRedirectUrl = cannyFactory.getRedirectUrl();
            const referrer = $state.href(toState.name, toParams);
            $ngRedux.dispatch(saveAfterLoginPath());
            $state.go(newTarget, { cannyRedirectUrl, r: referrer });
          }
        }
      );

      $rootScope.$on('$stateChangeSuccess', (e, toState, toParams) => {
        const data = toState.data || {};
        this.state.bodyClass = data.bodyClass;
        this.state.title = data.title || 'home.title.default';
        this.state.description = data.description || '';
        this.state.prerenderStatusCode = data.prerenderStatusCode || '';
      });

      checkOnline.start();

      $scope.forceReload = function () {
        $window.location.reload(true);
      };
    }
  ).name;
